module.exports = __webpack_public_path__ + "img/house-chimney-window.f58892d6.svg";